
export default {
  transition: 'page',
  head () {
    return {
      title: 'Contact us',
      bodyAttrs: {
        class: 'page-contact page-default'
      }
    }
  },
  data () {
    return {
      subjects: [
        { value: 'payment-issue', label: 'Payment issue' },
        { value: 'account-issue', label: 'Account issue' },
        { value: 'product-issue', label: 'Product issue' },
        { value: 'design-service', label: 'Design Service' },
        { value: 'training', label: 'Training' },
        { value: 'cooperation', label: 'Cooperation' },
        { value: 'Other', label: 'Other' }
      ]
    }
  }
}
